export const claim_access = [
  "Plataforma GBA",
  "Ventanilla Única",
  "Correo Electronico",
  "Derivado de otro Organismo",
  "Reclamo Presencial",
];
export const type_of_claim = [
  "S/A",
  "Común - Común",
  "HV - Por afectacion de derechos de NNyA",
  "HV - Jubilados o pensionados",
  "HV - Por estado físico o mental",
  "HV - Por ruralidad",
  "HV - Por razones, sociales, económicas o culturales",
  "HV - Por turista",
  "HV - Por migrante",
  "HV - Por colectivo LGTB+",
  "HV - Por pueblos originarios",
  "HV - Mayores de 70años",
  "HV - Otro",
];
export const category = [
  "Sin clasificar",
  "Bienes",
  "Servicios",
  "Bienes Inmuebles",
];
export const heading = [
  "Alimentos y Bebidas",
  "Colchoneria",
  "Construccion",
  "Electrodomesticos y Artefactos para el Hogar",
  "Equipos de Telefonia",
  "Indumentaria, Textil, Calzado, Marroquineria",
  "Informatica",
  "Muebles",
  "Planes de Ahorro Previo para Fines Determinados",
  "Rodados, Automotores y Embarcaciones",
  "Servicio de Comunicaciones",
  "Servicios de Salud",
  "Servicios de Transporte Terrestre y Aereo",
  "Servicios Financieros y Seguros",
  "Servicios Publicos Domiciliarios",
  "Servicios Turisticos",
  "Servicios Culturales y Deportivos",
  "Servicios de Enseñanza",
  "Servicios de Transporte",
  "Administracion de Consorcios",
  "Alquileres",
  "Servicios de alerta",
  "Guardamuebles",
];
export const subheading = [
  "Alimentos y Bebidas",
  "Colchoneria",
  "Construccion",
  "Electrodomesticos y Artefactos para el Hogar",
  "Equipos de Telefonia",
  "Indumentaria, Textil, Calzado, Marroquineria - Accesorios",
  "Indumentaria, Textil, Calzado, Marroquineria - Blanquerias",
  "Indumentaria, Textil, Calzado, Marroquineria - Deportiva",
  "Indumentaria, Textil, Calzado, Marroquineria - Indumentaria",
  "Informatica",
  "Muebles",
  "Planes de Ahorro Previo para Fines Determinados",
  "Rodados, Automotores y Embarcaciones",
  "Servicio de Comunicaciones - Internet",
  "Servicio de Comunicaciones - Paquetes de productos",
  "Servicio de Comunicaciones - Telefonia fija – Correos postales",
  "Servicio de Comunicaciones - Telefonía móvil",
  "Servicio de Comunicaciones - Tv por cable o satelital",
  "Servicios de Salud",
  "Servicios de Transporte Terrestre y Aereo",
  "Servicios Financieros y Seguros - Billeteras virtuales",
  "Servicios Financieros y Seguros - Administración de rutas y autopistas",
  "Servicios Financieros y Seguros - Caja de ahorros, cuenta corriente",
  "Servicios Financieros y Seguros - Compañias financieras",
  "Servicios Financieros y Seguros - Administración de pagos",
  "Servicios Financieros y Seguros - Débitos automáticos",
  "Servicios Financieros y Seguros - Paquetes de productos",
  "Servicios Financieros y Seguros - Prestamos personales",
  "Servicios Financieros y Seguros - Seguros (vida, auto, hogar)",
  "Servicios Financieros y Seguros - Tarjetas de créditos, débitos y de compras",
  "Servicios Financieros y Seguros - Tarjetas de descuentos (LN, 365)",
  "Servicios Publicos Domiciliarios - Aguas y servicios cloacales",
  "Servicios Publicos Domiciliarios - Gas por red",
  "Servicios Publicos Domiciliarios - Luz",
  "Servicios Turisticos - Excursiones",
  "Servicios Turisticos - Hoteles, hosterías, hospedajes, albergues, campings, etc.",
  "Servicios Turisticos - Paquetes turísticos y Pasajes",
  "Servicios Turisticos - Parques Nacionales",
  "Servicios y eventos de esparcimiento, culturales y/o deportivos",
  "Servicios de Salud sin cobertura",
  "Servicios de Salud con OS o EMP",
  "Servicios de Enseñanza",
  "Servicios de Transporte fluvial o marítimo de pasajeros y cargas",
  "Administracion de consorcios",
  "Alquileres",
  "Servicios de Seguridad - Alarmas y servicios de alerta",
  "Servicios de estacionamientos y guardamuebles",
  "Sin clasificar",
];
export const reason = [
  "Baja no solicitada",
  "Clausulas abusivas",
  "Cobro indebido",
  "Conectividad deficiente",
  "Corte de servicio",
  "Cumplimiento parcial o defectuoso de la prestación del servicio",
  "Demora excesiva para el cumplimiento de prestaciones médicas",
  "Desalojo",
  "Desconocimiento de descuento",
  "Descuento de crédito no solicitado",
  "Error en descuentos",
  "Falta de cumplimiento garantía posventa",
  "Falta de Información relevante",
  "Falta de procesamiento de baja del servicio",
  "Imposibilidad de baja del servicio",
  "Aumento",
  "Incumplimiento de garantía",
  "Incumplimiento de la oferta",
  "Incumplimiento total o parcial de la prestación del servicio",
  "Incumplimiento del contrato",
  "Incumplimiento del servicio",
  "Incumplimiento Resolución BCRA",
  "Interrupción o corte de suministro",
  "Negativa o falta de cobertura total de la prestación comprometida",
  "No entrega de producto",
  "No entrega del producto por compra online",
  "No reconocimiento de pagos",
  "No reintegro de dinero",
  "Prácticas abusivas",
  "Consumos no realizados",
  "Problemas de facturación - Facturación excesiva",
  "Negación de la práctica",
  "Entrega defectuosa - Producto dañado",
  "Falta de turno",
  "Sin clasificar",
  "Clausulas Abusivas - Art. 37 Ley 24.240",
  "Cancelación o supresión de vuelos",
  "Problemas de fraude o estafa",
  "Débitos y/o cobros indebidos",
  "Rechazo de la devolución del bien",
];

export const companys = [
  { id: 0, name: "Empresa A", cuit: "30-12345678-9" },
  { id: 1, name: "Empresa B", cuit: "30-87654321-0" },
  { id: 2, name: "Empresa C", cuit: "30-56781234-5" },
];

export const omics = [
  "Nueve de Julio",
  "Veinticinco de Mayo",
  "Adolfo Alsina",
  "Adolfo Gonzales Chaves",
  "Alberti",
  "Almirante Brown",
  "Arrecifes",
  "Avellaneda",
  "Ayacucho",
  "Azul",
  "Bahía Blanca",
  "Balcarce",
  "Baradero",
  "Benito Juárez",
  "Berazategui",
  "Berisso",
  "Bolívar",
  "Bragado",
  "Brandsen",
  "Campana",
  "Cañuelas",
  "Capitán Sarmiento",
  "Carlos Casares",
  "Carlos Tejedor",
  "Carmen de Areco",
  "Castelli",
  "Chacabuco",
  "Chascomús",
  "Chivilcoy",
  "Colón",
  "Coronel Dorrego",
  "Coronel Pringles",
  "Coronel Rosales",
  "Coronel Suárez",
  "Daireaux",
  "Dolores",
  "Ensenada",
  "Escobar",
  "Esteban Echeverría",
  "Exaltación de la Cruz",
  "Ezeiza",
  "Florencio Varela",
  "Florentino Ameghino",
  "General Alvarado",
  "General Alvear",
  "General Arenales",
  "General Belgrano",
  "General Guido",
  "General Lamadrid",
  "General Las Heras",
  "General Lavalle",
  "General Madariaga",
  "General Paz",
  "General Pinto",
  "General Pueyrredón",
  "General Rodríguez",
  "General San Martín",
  "General Viamonte",
  "General Villegas",
  "Guaminí",
  "Hipólito Yrigoyen",
  "Hurlingham",
  "Ituzaingó",
  "José C. Paz",
  "Junín",
  "La Costa",
  "La Matanza",
  "La Plata",
  "Lanús",
  "Laprida",
  "Las Flores",
  "Leandro N. Alem",
  "Lezama",
  "Lincoln",
  "Lobería",
  "Lobos",
  "Lomas de Zamora",
  "Luján",
  "Magdalena",
  "Maipú",
  "Malvinas Argentinas",
  "Mar Chiquita",
  "Marcos Paz",
  "Mercedes",
  "Merlo",
  "Monte",
  "Monte Hermoso",
  "Moreno",
  "Morón",
  "Navarro",
  "Necochea",
  "Olavarría",
  "Patagones",
  "Pehuajó",
  "Pellegrini",
  "Pergamino",
  "Pila",
  "Pilar",
  "Pinamar",
  "Presidente Perón",
  "Puán",
  "Punta Indio",
  "Quilmes",
  "Ramallo",
  "Rauch",
  "Rivadavia",
  "Rojas",
  "Roque Pérez",
  "Saavedra",
  "Saladillo",
  "Saliqueló",
  "Salto",
  "San Andrés de Giles",
  "San Antonio de Areco",
  "San Cayetano",
  "San Fernando",
  "San Isidro",
  "San Miguel",
  "San Nicolás",
  "San Pedro",
  "San Vicente",
  "Suipacha",
  "Tandil",
  "Tapalqué",
  "Tigre",
  "Tordillo",
  "Tornquist",
  "Trenque Lauquen",
  "Tres Arroyos",
  "Tres de Febrero",
  "Tres Lomas",
  "Vicente López",
  "Villa Gesell",
  "Villarino",
  "Zárate",
];
export const claim_status = [
  "Caratulado",
  "DNDC / Coprec",
  "Derivado a Salud Pública",
  "Derivado a otro Organismo",
  "Derivado al Municipio",
  "En análisis",
  "En trámite",
  "Intima por última vez",
  "Intimación",
  "Intimación IVE",
  "Notifica Acta de audiencia",
  "Para Audiencia",
  "Rechazado",
  "Resuelto",
  "Traslado a empresa",
  "Traslado al Consumidor"
];

export const gender = {
    female: "Femenino",
    male: "Masculino",
    x: "X",
    other: "Otro",
    none: "Prefiero no decirlo",
}